import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  BsBuildingFillAdd,
  BsCalendar2CheckFill,
  BsCalendar3RangeFill,
  BsCalendarWeekFill,
  BsClipboardDataFill,
  BsDatabaseFill,
  BsFileEarmarkTextFill,
  BsFillPassFill,
  BsHouseFill,
  BsMailbox2Flag,
  BsPatchCheckFill,
  BsPeopleFill,
  BsFillCalculatorFill,
  BsRocketFill,
  BsSendFill,
} from "react-icons/bs";
import SidebarMenu from "react-bootstrap-sidebar-menu";
import { selectedApiUrl } from "../context/AuthContext";
import { isAdminRole } from "../util/Permissions";

const sidebarStyle = {
  width: "305px"
};

const Sidebar = ({ props, buildVersion = null, user = null }) => {
  const location = useLocation();
  const getCurrentActive = (location) => {
    if (location == null) return "/";
    return location.pathname;
  };
  const [active, setActive] = useState(window.location.pathname);

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const updateKey = (eventKey) => {
    setActive(eventKey);
  };

  const displayBuildVersion = () => {
    if (buildVersion == null) return "";
    return (
      <SidebarMenu.Footer>
        <div className={"navDivider"}></div>
        <div className={"nav-txt-align"}>
          <p className={"text-axis-offblack"}>Build: {buildVersion}</p>
          <p className={"text-axis-offblack"}>Api: {selectedApiUrl()}</p>
        </div>
      </SidebarMenu.Footer>
    );
  };

  return (
    <SidebarMenu
      className={"sidebar-wrapper"}
      variant={"light"}
      expand={false}
      activeKey={active}
      onSelect={updateKey}
      style={sidebarStyle}
    >
      {/*<p className={"nav-txt-align"}>Home{location.pathname}</p>*/}
      <SidebarMenu.Body className={"p-0 m-0"}>
        <SidebarMenu.Nav>
          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/"
              to={"/"}
            >
              <SidebarMenu.Nav.Icon>
                <BsHouseFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Dashboard</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/shifts"
              to={"/shifts"}
            >
              <SidebarMenu.Nav.Icon>
                <BsCalendarWeekFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Shifts</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/live"
              to={"/live"}
            >
              <SidebarMenu.Nav.Icon>
                <BsRocketFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Live Shifts</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/timesheets"
              to={"/timesheets"}
            >
              <SidebarMenu.Nav.Icon>
                <BsCalendar3RangeFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Timesheets</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          {isAdminRole(user?.role) && (
            <SidebarMenu.Nav>
              <SidebarMenu.Nav.Link
                onClick={() => localStorage.removeItem("history")}
                as={Link}
                eventKey="/invoices"
                to={"/invoices"}
              >
                <SidebarMenu.Nav.Icon>
                  <BsFillCalculatorFill size={30} />
                </SidebarMenu.Nav.Icon>
                <SidebarMenu.Nav.Title className="text-nowrap">Invoices</SidebarMenu.Nav.Title>
              </SidebarMenu.Nav.Link>
            </SidebarMenu.Nav>
          )}

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/users"
              to={"/users"}
            >
              <SidebarMenu.Nav.Icon>
                <BsPeopleFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Users</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/references"
              to={"/references"}
            >
              <SidebarMenu.Nav.Icon>
                <BsFileEarmarkTextFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">References</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/statistics"
              to={"/statistics"}
            >
              <SidebarMenu.Nav.Icon>
                <BsClipboardDataFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Statistics</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/messages"
              to={"/messages"}
            >
              <SidebarMenu.Nav.Icon>
                <BsSendFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Messaging</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/emails"
              to={"/emails"}
            >
              <SidebarMenu.Nav.Icon>
                <BsMailbox2Flag size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Email Inbox</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey="/nurse-certificates"
              to={"/nurse-certificates"}
            >
              <SidebarMenu.Nav.Icon
                className={"sidebar-remove-collapse-icon-style"}
              >
                <BsPatchCheckFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Nurse Certificates</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey={"/availability"}
              to={"/availability"}
            >
              <SidebarMenu.Nav.Icon
                className={"sidebar-remove-collapse-icon-style"}
              >
                <BsCalendar2CheckFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Availability Table</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey={"/availabilityCards"}
              to={"/availabilityCards"}
            >
              <SidebarMenu.Nav.Icon
                className={"sidebar-remove-collapse-icon-style"}
              >
                <BsFillPassFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Availability Cards</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey={"/reports"}
              to={"/reports"}
            >
              <SidebarMenu.Nav.Icon
                className={"sidebar-remove-collapse-icon-style"}
              >
                <BsDatabaseFill size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Reports</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>

          <SidebarMenu.Nav>
            <SidebarMenu.Nav.Link
              onClick={() => localStorage.removeItem("history")}
              as={Link}
              eventKey={"/facilities"}
              to={"/facilities"}
            >
              <SidebarMenu.Nav.Icon
                className={"sidebar-remove-collapse-icon-style"}
              >
                <BsBuildingFillAdd size={30} />
              </SidebarMenu.Nav.Icon>
              <SidebarMenu.Nav.Title className="text-nowrap">Facilities</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
          </SidebarMenu.Nav>
        </SidebarMenu.Nav>
      </SidebarMenu.Body>
      {displayBuildVersion()}
    </SidebarMenu>
  );
};

export default Sidebar;
